import { render, staticRenderFns } from "./CorrectZone.vue?vue&type=template&id=73cbd4ce&lang=pug"
import script from "./CorrectZone.vue?vue&type=script&lang=js"
export * from "./CorrectZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports